import { gql } from "@apollo/client";

const recordOrderProductionJobBoxLocationMutation = gql`
  mutation ($location: String!, $orderProductionJobId: ID!) {
    recordOrderProductionJobBoxLocation(
      location: $location
      orderProductionJobId: $orderProductionJobId
    ) {
      errors {
        orderProductionJobId
      }
      updatedOrderProductionJob {
        id
        latestBoxLocation {
          id
          location
        }
        boxLocationHistory {
          id
          createdAt
          createdBy {
            id
            name(format: FIRST_NAME_LAST_NAME)
          }
          location
        }
        order {
          id
          highDefinitionDigitalStatus
        }
      }
      succeeded
    }
  }
`;

export default recordOrderProductionJobBoxLocationMutation;
